import seizureSafeIcon from "../../icons/seizureSafeIcon.svg"
import adhdIcon from "../../icons/adhdIcon.svg"
import lowVisionIcon from "../../icons/lowVisionIcon.svg"
import epilepsySafeIcon from "../../icons/epilepsySafeIcon.svg"

export default [
    {
        label: 'Low Vision',
        key: 'low-vision-profile',
        icon: lowVisionIcon,
    },
    {
        label: 'ADHD',
        key: 'adhd-profile',
        icon: adhdIcon,
    },
    {
        label: 'Seizure Safe',
        key: 'seizure-safe-profile',
        icon: seizureSafeIcon,
    },
    {
        label: 'Epilepsy Safe Mode',
        key: 'epilepsy-safe-profile',
        icon: epilepsySafeIcon,
    },
]
